<p class="text-md font-medium">Comments</p>
<mat-divider
  role="separator"
  class="mat-divider mt-1 mb-1 mat-divider-horizontal"
  aria-orientation="horizontal"
></mat-divider>
<comment-view [relatedToId]="project.id" relatedToType="Project" [account]="account"></comment-view>
